/**
 * Default landing path after login for each staff role.
 * Role reference (users.role):
 * 1 Super Admin | 3 Ops/Admin | 4 Sales | 5 Finance | 7 Cafe
 * 9 Personal Trainer | 10 Nutrition | 11 Fitness Manager | 12 HR
 * 13 Employee (self-service) | 15 Physio | 16 Social Media | 17 General Trainer
 *
 * Housekeeping / facility / other generic jobs must NOT land on the
 * Personal Trainer portal. Role 9 is trainer-only when the designation
 * is actually a trainer.
 */
export const EMPLOYEE_ROLE = "13";
export const GENERAL_TRAINER_ROLE = "17";

export const TRAINER_DESIGNATION_IDS = ["1", "18", "76"];

const SPECIALIZED_HOMES = {
  "1": "/admin-dashboard",
  "3": "/dashboard",
  "4": "/dashboard",
  "5": "/finance-v2/dashboard",
  "7": "/cafe-dashboard",
  "10": "/nutrition/dashboard",
  "11": "/fitness-manager-dashboard",
  "12": "/hr-dashboard",
  "15": "/physio/dashboard",
  "16": "/social-media-dashboard",
  "17": "/gt-dashboard",
};

export function isTrainerDesignation(designationId) {
  return TRAINER_DESIGNATION_IDS.includes(String(designationId ?? ""));
}

/** Role 9 + a real trainer designation (or a legacy session with no designation yet). */
export function usesTrainerPortal(role, designationId) {
  if (String(role ?? "") !== "9") return false;
  if (designationId == null || designationId === "") return true;
  return isTrainerDesignation(designationId);
}

/**
 * Generic staff: empty role, Employee (13), or a non-trainer given role 9 by mistake.
 * These logins only get Employee Dashboard — not PT / sales / admin menus.
 */
export function usesEmployeeOnlyShell(role, designationId) {
  const r = String(role ?? "");
  if (!r || r === EMPLOYEE_ROLE) return true;
  if (r === "9") {
    if (designationId == null || designationId === "") return false;
    return !isTrainerDesignation(designationId);
  }
  return false;
}

export function getRoleHomePath(role, designationId) {
  if (usesEmployeeOnlyShell(role, designationId)) {
    return "/employee-dashboard";
  }
  if (usesTrainerPortal(role, designationId)) {
    return "/pt-dashboard";
  }
  const r = String(role ?? "");
  return SPECIALIZED_HOMES[r] || "/employee-dashboard";
}
